(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["neyva-bundle-offer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('neyva-bundle-offer')) return;

    class NeyvaBundleOffer extends HTMLElement {
      connectedCallback() {
        const dataEl = this.querySelector('script[data-neyva-bundle-data]');
        if (!dataEl) return;
        try {
          this.data = JSON.parse(dataEl.textContent);
        } catch (error) {
          console.warn('[neyva-bundle] Daten nicht lesbar', error);
          return;
        }

        this.section = this.closest('.shopify-section') || document.body;
        this.ownSize = this.data.currentSize;
        this.partnerIndex = 0;
        const checkedSize = this.querySelector('input[name^="neyva-size-"]:checked');
        this.partnerSize = checkedSize ? checkedSize.value : this.ownSize;
        const checkedMode = this.querySelector('input[name^="neyva-mode-"]:checked');
        this.mode = checkedMode ? checkedMode.value : 'single';

        this.onOwnChange = this.onOwnChange.bind(this);
        this.onInnerChange = this.onInnerChange.bind(this);
        this.onCtaClick = this.onCtaClick.bind(this);

        this.addEventListener('change', this.onInnerChange);
        this.section.addEventListener('change', this.onOwnChange);
        this.querySelector('[data-neyva-cta]')?.addEventListener('click', this.onCtaClick);

        this.applyMode();
        this.update();
      }

      disconnectedCallback() {
        this.section?.removeEventListener('change', this.onOwnChange);
        this.section?.classList.remove('neyva-bundle-mode');
      }

      /* Groesse der ersten Hose kommt aus der normalen Groessenauswahl der Produktseite */
      onOwnChange(event) {
        const target = event.target;
        if (!(target instanceof HTMLElement) || !target.closest('variant-picker')) return;
        if (target.matches('input[type="radio"]') && !target.checked) return;
        if (!('value' in target) || !target.value) return;
        const previous = this.ownSize;
        this.ownSize = target.value;
        if (this.partnerSize === previous) this.partnerSize = this.ownSize;
        this.syncSizeInputs();
        this.update();
      }

      onInnerChange(event) {
        const target = event.target;
        if (!(target instanceof HTMLInputElement)) return;
        event.stopPropagation();
        if (target.name.startsWith('neyva-mode-')) {
          this.mode = target.value;
          this.applyMode();
        } else if (target.name.startsWith('neyva-partner-')) {
          this.partnerIndex = Number(target.value) || 0;
        } else if (target.name.startsWith('neyva-size-')) {
          this.partnerSize = target.value;
        }
        this.update();
      }

      applyMode() {
        const isBundle = this.mode === 'bundle';
        const panel = this.querySelector('[data-neyva-panel]');
        if (panel) panel.hidden = !isBundle;
        this.section.classList.toggle('neyva-bundle-mode', isBundle);
      }

      syncSizeInputs() {
        this.querySelectorAll('input[name^="neyva-size-"]').forEach((input) => {
          input.checked = input.value === this.partnerSize;
        });
      }

      get partner() {
        return this.data.partners[this.partnerIndex] || this.data.partners[0];
      }

      findVariant(ownSize, partnerSize, partner = this.partner) {
        if (!partner) return null;
        return partner.variants.find((v) => v.own === ownSize && v.partner === partnerSize) || null;
      }

      update() {
        const partner = this.partner;
        if (!partner) return;
        const isDemo = this.dataset.demo === 'true';

        const own = this.querySelector('[data-neyva-own]');
        if (own) own.textContent = `${this.data.ownColor} · ${this.data.sizeLabel} ${this.ownSize}`;
        const colorLabel = this.querySelector('[data-neyva-partner-color]');
        if (colorLabel) colorLabel.textContent = partner.color;
        const sizeLabel = this.querySelector('[data-neyva-partner-size]');
        if (sizeLabel) sizeLabel.textContent = this.partnerSize;

        this.querySelectorAll('input[name^="neyva-partner-"]').forEach((input) => {
          const candidate = this.data.partners[Number(input.value)];
          const hasStock =
            isDemo || Boolean(candidate && candidate.variants.some((v) => v.own === this.ownSize && v.available));
          input.closest('.neyva-bundle__swatch')?.classList.toggle('is-unavailable', !hasStock);
        });

        this.querySelectorAll('input[name^="neyva-size-"]').forEach((input) => {
          const variant = this.findVariant(this.ownSize, input.value);
          const available = isDemo || Boolean(variant && variant.available);
          input.closest('.neyva-bundle__size')?.classList.toggle('is-unavailable', !available);
          input.setAttribute('aria-disabled', String(!available));
        });

        if (isDemo) return;

        const button = this.querySelector('[data-neyva-cta]');
        const text = this.querySelector('[data-neyva-cta-text]');
        const icon = this.querySelector('[data-neyva-cta-icon]');
        const total = this.querySelector('[data-neyva-total]');
        const variant = this.findVariant(this.ownSize, this.partnerSize);
        const available = Boolean(variant && variant.available);
        if (button) button.disabled = !available;
        if (text) text.textContent = available ? this.data.addText : this.data.soldOutText;
        if (icon) icon.hidden = !available;
        if (total && variant) total.textContent = variant.price;
        this.showError('');
      }

      showError(message) {
        const el = this.querySelector('[data-neyva-error]');
        if (!el) return;
        el.textContent = message;
        el.hidden = !message;
      }

      async onCtaClick() {
        if (this.dataset.demo === 'true') {
          this.showError(this.data.demoText);
          return;
        }
        const variant = this.findVariant(this.ownSize, this.partnerSize);
        const button = this.querySelector('[data-neyva-cta]');
        if (!variant || !variant.available || !button) return;

        button.disabled = true;
        button.setAttribute('aria-busy', 'true');

        const routes = (window.Theme && window.Theme.routes) || {};
        const addUrl = routes.cart_add_url || '/cart/add.js';
        const cartUrl = routes.cart_url || '/cart';

        let events = null;
        try {
          events = await import('@shopify/events');
        } catch (error) {
          events = null;
        }

        const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
          .map((el) => el.dataset.sectionId)
          .filter(Boolean);

        const body = { items: [{ id: variant.id, quantity: 1 }] };
        if (sectionIds.length) {
          body.sections = sectionIds.join(',');
          body.sections_url = window.location.pathname;
        }

        let deferred = null;
        if (events && events.CartLinesUpdateEvent) {
          deferred = events.CartLinesUpdateEvent.createPromise();
          this.dispatchEvent(
            new events.CartLinesUpdateEvent({
              action: 'add',
              context: 'product',
              lines: [{ merchandiseId: String(variant.id), quantity: 1 }],
              promise: deferred.promise,
            })
          );
        }

        const fetchCart = () =>
          fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then((r) =>
            r.json()
          );

        try {
          const response = await fetch(addUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          });
          const result = await response.json();
          if (!response.ok || result.status) {
            throw new Error(result.description || result.message || 'Das hat leider nicht geklappt.');
          }

          button.dataset.added = 'true';
          window.setTimeout(() => button.removeAttribute('data-added'), 1600);

          const cart = await fetchCart();
          if (deferred) {
            deferred.resolve({
              cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
              detail: {
                items: cart.items,
                sections: result.sections,
                itemCount: 1,
                source: 'neyva-bundle-offer',
                sourceId: this.id,
                productId: String(this.data.productId),
                didError: false,
              },
            });
          } else {
            window.location.href = cartUrl;
          }
        } catch (error) {
          this.showError(error && error.message ? error.message : 'Das hat leider nicht geklappt.');
          if (deferred) {
            try {
              const cart = await fetchCart();
              deferred.resolve({
                cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
                detail: { items: cart.items, didError: true, source: 'neyva-bundle-offer', sourceId: this.id },
              });
            } catch (cartError) {
              deferred.reject(cartError);
            }
          }
        } finally {
          button.removeAttribute('aria-busy');
          const current = this.findVariant(this.ownSize, this.partnerSize);
          button.disabled = !(current && current.available);
        }
      }
    }

    customElements.define('neyva-bundle-offer', NeyvaBundleOffer);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["neyva-color-switcher"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('neyva-color-switcher')) return;

    class NeyvaColorSwitcher extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section') || document.body;
        this.onChange = this.onChange.bind(this);
        this.section.addEventListener('change', this.onChange);
      }

      disconnectedCallback() {
        this.section?.removeEventListener('change', this.onChange);
      }

      /* Neue Groesse in der normalen Groessenauswahl: Links der anderen Farben auf dieselbe Groesse setzen */
      onChange(event) {
        const target = event.target;
        if (!(target instanceof HTMLElement) || !target.closest('variant-picker')) return;
        if (target instanceof HTMLInputElement && target.type === 'radio' && !target.checked) return;
        if (!('value' in target) || !target.value) return;
        this.updateLinks(String(target.value));
      }

      updateLinks(size) {
        this.querySelectorAll('a[data-variants]').forEach((link) => {
          let map = {};
          try {
            map = JSON.parse(link.dataset.variants || '{}');
          } catch (error) {
            return;
          }
          const base = link.dataset.url || link.getAttribute('href');
          link.setAttribute('href', map[size] ? `${base}?variant=${map[size]}` : base);
        });
      }
    }

    customElements.define('neyva-color-switcher', NeyvaColorSwitcher);
  })();
  } catch(e) { console.error(e); }
})();

})();
